import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import Button from "../componentLibrary/Button";
import { useGetLegalDates } from "../api/queries";
import TermsContent from "./legal/TermsContent";

interface TermsOfServiceModalProps {
  open: boolean;
  onClose: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({
  open,
  onClose,
}) => {
  const { data: legalDates } = useGetLegalDates();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { maxHeight: "80vh" },
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="h2" className="font-bold">
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Last updated:{" "}
          {legalDates?.termsLastUpdated
            ? new Date(legalDates.termsLastUpdated).toLocaleDateString()
            : "Loading..."}
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 3 }}>
        <TermsContent showLastUpdated={false} />
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} variant="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfServiceModal;
